/**
 * ClickHouse timing
 */

import axios from 'axios';
import browser from 'detect-browser';

class Timing {
  constructor(serverInfo) {
    this.apiURL = 'https://datagather.xsolla.com/xls';
    this.performance =
      (window.performance || {}).now !== undefined &&
      (window.performance || {}).timing !== undefined
        ? window.performance
        : null;
    this.serverInfo = serverInfo;
  }

  request(json) {
    return axios({
      method: 'POST',
      url: this.apiURL,
      withCredentials: false,
      data: JSON.stringify(json)
    });
  }

  static buildSchemaAndRecords(timingData) {
    const json = {};

    timingData.forEach(column => {
      const field = {
        name: column.name,
        type: column.type
      };

      if (column.default !== undefined) {
        field.default = column.default;
      }

      if (column.value === null || column.value === undefined) {
        json[column.name] = null;
      } else if (typeof column.value === 'number') {
        if (column.type.indexOf('int') !== -1) {
          json[column.name] = Math.round(column.value);
        } else {
          json[column.name] = column.value;
        }
      } else {
        json[column.name] = typeof column.value !== 'undefined' && column.value.toString();
      }
    });

    return json;
  }

  sendLoadReport() {
    if (!this.performance) {
      return;
    }

    const {performance, serverInfo} = this;
    const {timing} = performance;

    /* eslint-disable no-restricted-globals */
    const timingData = [
      {
        name: 'date',
        value: serverInfo.date,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'ip',
        value: serverInfo.ip,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'location_url',
        value: location.href,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'location_host',
        value: location.host,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'location_path',
        value: location.pathname,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'location_search',
        value: location.search,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'browser',
        value: browser && browser.name,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'browser_version',
        value: browser && browser.version.toString(),
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'redirect_time',
        value: timing.redirectEnd > 0 ? timing.redirectEnd - timing.navigationStart : 0,
        type: ['null', 'int'],
        default: null
      },
      {
        name: 'html_load_time',
        value: timing.responseEnd - timing.navigationStart,
        type: ['null', 'int'],
        default: null
      },
      {
        name: 'dom_content_load_time',
        value: timing.domContentLoadedEventEnd - timing.navigationStart,
        type: ['null', 'int'],
        default: null
      },
      {
        name: 'geoip_country',
        value: serverInfo.geo.country,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'geoip_region',
        value: serverInfo.geo.region,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'geoip_city',
        value: serverInfo.geo.city,
        type: ['null', 'string'],
        default: null
      },
      {
        name: 'geoip_latitude',
        value: serverInfo.geo.ll ? serverInfo.geo.ll[0] : null,
        type: ['null', 'double'],
        default: null
      },
      {
        name: 'geoip_longitude',
        value: serverInfo.geo.ll ? serverInfo.geo.ll[1] : null,
        type: ['null', 'double'],
        default: null
      },
      {
        name: 'server_name',
        value: serverInfo.name || null,
        type: ['null', 'string'],
        default: null
      }
    ];
    /* eslint-enable no-restricted-globals */

    const data = Timing.buildSchemaAndRecords(timingData);

    this.request(data);
  }
}

export default Timing;



// WEBPACK FOOTER //
// ./utils/timing.js